module.exports = __webpack_public_path__ + "static/thumb-ondemand-api-93e2423562f817543357a7abff04bd68.png";